import React, { useState, useEffect, useCallback } from 'react';
import './AdminSuscriptores.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/leads.php';

/* ── Icons ── */
const IconSearch   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUsers    = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconMail     = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/><polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconDownload = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconEye      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconInstagram= () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconWeb      = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconFilter   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconExport   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="17 8 12 3 7 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

/* ── Helpers ── */
const FUENTE_ICON = {
  instagram: <IconInstagram/>, facebook: <IconInstagram/>,
  whatsapp:  <IconWhatsapp/>,  web: <IconWeb/>,
  boletin:   <IconMail/>,      boletin_comunidad: <IconMail/>,
  directo:   <IconWeb/>,
};
const PERFIL_COLORS = { profesional:'verde', familia:'azul', estudiante:'amarillo', otro:'gris' };

function fmtFecha(str) {
  if (!str) return '—';
  const d = new Date(str);
  return d.toLocaleDateString('es-PE', { day:'2-digit', month:'short', year:'numeric' });
}

/* ════════════════════════════════════════
   COMPONENTE PRINCIPAL
════════════════════════════════════════ */
export default function AdminSuscriptores() {
  const [susc,      setSusc]      = useState([]);
  const [loading,   setLoading]   = useState(false);
  const [busqueda,  setBusqueda]  = useState('');
  const [filtroActivo, setFiltroActivo] = useState('todos'); // todos | activos | con_descargas
  const [filtroPerfil, setFiltroPerfil] = useState('todos');
  const [toast,     setToast]     = useState(null);
  const [modalSusc, setModalSusc] = useState(null); // suscriptor seleccionado
  const [descargas, setDescargas] = useState([]);   // descargas del modal
  const [loadingDesc, setLoadingDesc] = useState(false);

  const showToast = (msg, tipo='ok') => {
    setToast({msg,tipo}); setTimeout(()=>setToast(null),3000);
  };

  /* ── Fetch suscriptores ── */
  const fetchSusc = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=suscriptores_list&limit=500`);
      const j = await r.json();
      if (j.success) setSusc(j.data?.items || []);
    } catch(e) { showToast('Error cargando suscriptores','error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchSusc(); }, [fetchSusc]);

  /* ── Ver descargas de un suscriptor ── */
  const verDescargas = async (s) => {
    setModalSusc(s);
    setDescargas([]);
    setLoadingDesc(true);
    try {
      // Buscar lead_id por email para consultar sus descargas
      const r = await fetch(`${API}?action=descargas_usuario&email=${encodeURIComponent(s.email)}`);
      const j = await r.json();
      if (j.success) setDescargas(j.data || []);
    } catch(e) {}
    finally { setLoadingDesc(false); }
  };

  /* ── Exportar CSV ── */
  const exportarCSV = () => {
    const headers = ['Nombre','Email','Teléfono','Perfil','Fuente','Descargas','Activo','Confirmado','Fecha'];
    const rows = filtrados.map(s => [
      s.nombre, s.email, s.telefono||'', s.perfil,
      s.fuente||'web', s.total_descargas||0,
      s.activo?'Sí':'No', s.confirmado?'Sí':'No',
      fmtFecha(s.created_at)
    ]);
    const csv = [headers, ...rows].map(r => r.map(v => `"${v}"`).join(',')).join('\n');
    const blob = new Blob(['\ufeff'+csv], { type:'text/csv;charset=utf-8;' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = `suscriptores_${new Date().toISOString().slice(0,10)}.csv`;
    a.click(); URL.revokeObjectURL(url);
    showToast('CSV exportado correctamente');
  };

  /* ── Filtrar ── */
  const q = busqueda.toLowerCase();
  const filtrados = susc.filter(s => {
    const matchBus    = !q || s.nombre?.toLowerCase().includes(q) || s.email?.toLowerCase().includes(q);
    const matchActivo = filtroActivo === 'todos'
      || (filtroActivo === 'activos'        && s.activo == 1)
      || (filtroActivo === 'con_descargas'  && parseInt(s.total_descargas||0) > 0)
      || (filtroActivo === 'sin_descargas'  && parseInt(s.total_descargas||0) === 0);
    const matchPerfil = filtroPerfil === 'todos' || s.perfil === filtroPerfil;
    return matchBus && matchActivo && matchPerfil;
  });

  /* ── KPIs ── */
  const totalDescargas  = susc.reduce((a,s)=>a+(parseInt(s.total_descargas||0)),0);
  const conDescargas    = susc.filter(s=>parseInt(s.total_descargas||0)>0).length;
  const confirmados     = susc.filter(s=>s.confirmado==1).length;
  const activos         = susc.filter(s=>s.activo==1).length;

  return (
    <div className="as-page">

      {toast && (
        <div className={`as-toast as-toast--${toast.tipo}`}>
          {toast.tipo==='ok'?<IconCheck/>:<IconClose/>} {toast.msg}
        </div>
      )}

      {/* HEADER */}
      <div className="as-header">
        <div>
          <h1>Suscriptores</h1>
          <p>Gestiona los usuarios del boletín y sus descargas</p>
        </div>
        <div className="as-header__actions">
          <button className="as-btn-ghost" onClick={fetchSusc}><IconRefresh/> Actualizar</button>
          <button className="as-btn-ghost" onClick={exportarCSV}><IconExport/> Exportar CSV</button>
        </div>
      </div>

      {/* KPIs */}
      <div className="as-kpis">
        <div className="as-kpi as-kpi--verde">
          <div className="as-kpi__icon"><IconUsers/></div>
          <p>Suscriptores activos</p>
          <strong>{loading?'…':activos}</strong>
          <span>en el boletín</span>
        </div>
        <div className="as-kpi">
          <div className="as-kpi__icon as-kpi__icon--azul"><IconDownload/></div>
          <p>Descargas totales</p>
          <strong>{loading?'…':totalDescargas}</strong>
          <span>recursos descargados</span>
        </div>
        <div className="as-kpi">
          <div className="as-kpi__icon as-kpi__icon--amarillo"><IconCheck/></div>
          <p>Con descargas</p>
          <strong>{loading?'…':conDescargas}</strong>
          <span>de {susc.length} suscriptores</span>
        </div>
        <div className="as-kpi">
          <div className="as-kpi__icon as-kpi__icon--rosa"><IconMail/></div>
          <p>Emails confirmados</p>
          <strong>{loading?'…':confirmados}</strong>
          <span>han verificado su correo</span>
        </div>
      </div>

      {/* TOOLBAR */}
      <div className="as-toolbar">
        {/* Búsqueda */}
        <div className="as-search">
          <IconSearch/>
          <input
            type="text"
            placeholder="Buscar por nombre o email…"
            value={busqueda}
            onChange={e=>setBusqueda(e.target.value)}
          />
          {busqueda && (
            <button className="as-search__clear" onClick={()=>setBusqueda('')}>
              <IconClose/>
            </button>
          )}
        </div>

        {/* Filtro estado */}
        <div className="as-filtros">
          <IconFilter/>
          {[
            { id:'todos',         label:'Todos' },
            { id:'activos',       label:'Activos' },
            { id:'con_descargas', label:'Con descargas' },
            { id:'sin_descargas', label:'Sin descargas' },
          ].map(f=>(
            <button
              key={f.id}
              className={`as-filtro ${filtroActivo===f.id?'as-filtro--active':''}`}
              onClick={()=>setFiltroActivo(f.id)}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* Filtro perfil */}
        <select
          className="as-select"
          value={filtroPerfil}
          onChange={e=>setFiltroPerfil(e.target.value)}
        >
          <option value="todos">Todos los perfiles</option>
          <option value="profesional">Profesional</option>
          <option value="familia">Familia</option>
          <option value="estudiante">Estudiante</option>
          <option value="otro">Otro</option>
        </select>

        <span className="as-count">{filtrados.length} suscriptores</span>
      </div>

      {/* TABLA */}
      <div className="as-tabla-wrap as-card">
        <table className="as-tabla">
          <thead>
            <tr>
              <th>Suscriptor</th>
              <th>Perfil</th>
              <th>Fuente</th>
              <th>Descargas</th>
              <th>Estado</th>
              <th>Confirmado</th>
              <th>Fecha</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" className="as-loading-row">
                <div className="as-spinner"/>Cargando suscriptores…
              </td></tr>
            ) : filtrados.length === 0 ? (
              <tr><td colSpan="8" className="as-empty-row">
                {susc.length===0 ? 'Aún no hay suscriptores registrados' : 'Sin resultados para esa búsqueda'}
              </td></tr>
            ) : filtrados.map(s => (
              <tr key={s.id} className="as-tr">
                {/* Nombre + email */}
                <td>
                  <div className="as-susc-info">
                    <div className="as-avatar">{(s.nombre||'?')[0].toUpperCase()}</div>
                    <div>
                      <strong>{s.nombre}</strong>
                      <span>{s.email}</span>
                      {s.telefono && <span>{s.telefono}</span>}
                    </div>
                  </div>
                </td>

                {/* Perfil */}
                <td>
                  <span className={`as-badge as-badge--${PERFIL_COLORS[s.perfil]||'gris'}`}>
                    {s.perfil||'otro'}
                  </span>
                </td>

                {/* Fuente */}
                <td>
                  <span className="as-fuente">
                    {FUENTE_ICON[s.fuente]||<IconWeb/>}
                    {s.fuente||'web'}
                  </span>
                </td>

                {/* Descargas */}
                <td>
                  <span className={`as-desc-badge ${parseInt(s.total_descargas||0)>0?'as-desc-badge--ok':''}`}>
                    {s.total_descargas||0}
                  </span>
                </td>

                {/* Estado */}
                <td>
                  <span className={`as-estado ${s.activo?'as-estado--activo':'as-estado--inactivo'}`}>
                    {s.activo?'● Activo':'○ Inactivo'}
                  </span>
                </td>

                {/* Confirmado */}
                <td>
                  {s.confirmado
                    ? <span className="as-confirmado"><IconCheck/> Sí</span>
                    : <span className="as-pendiente">Pendiente</span>
                  }
                </td>

                {/* Fecha */}
                <td className="as-fecha">{fmtFecha(s.created_at)}</td>

                {/* Acción */}
                <td>
                  <button
                    className="as-btn-ver"
                    onClick={()=>verDescargas(s)}
                    title="Ver descargas"
                  >
                    <IconEye/> Ver
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ══ MODAL DESCARGAS DEL SUSCRIPTOR ══ */}
      {modalSusc && (
        <div className="as-overlay" onClick={()=>setModalSusc(null)}>
          <div className="as-modal" onClick={e=>e.stopPropagation()}>

            <div className="as-modal__head">
              <div className="as-modal__susc">
                <div className="as-avatar as-avatar--lg">{(modalSusc.nombre||'?')[0].toUpperCase()}</div>
                <div>
                  <h2>{modalSusc.nombre}</h2>
                  <p>{modalSusc.email}</p>
                  <div className="as-modal__badges">
                    <span className={`as-badge as-badge--${PERFIL_COLORS[modalSusc.perfil]||'gris'}`}>
                      {modalSusc.perfil}
                    </span>
                    <span className={`as-estado ${modalSusc.activo?'as-estado--activo':'as-estado--inactivo'}`}>
                      {modalSusc.activo?'Activo':'Inactivo'}
                    </span>
                  </div>
                </div>
              </div>
              <button className="as-modal__close" onClick={()=>setModalSusc(null)}><IconClose/></button>
            </div>

            <div className="as-modal__body">

              {/* Stats del suscriptor */}
              <div className="as-modal__stats">
                <div className="as-modal__stat">
                  <strong>{modalSusc.total_descargas||0}</strong>
                  <span>Descargas</span>
                </div>
                <div className="as-modal__stat">
                  <strong>{fmtFecha(modalSusc.created_at)}</strong>
                  <span>Suscrito desde</span>
                </div>
                <div className="as-modal__stat">
                  <strong>{modalSusc.fuente||'web'}</strong>
                  <span>Fuente</span>
                </div>
              </div>

              {/* Lista de descargas */}
              <div className="as-modal__section-title">
                <IconDownload/> Historial de descargas
              </div>

              {loadingDesc ? (
                <div className="as-modal__loading">
                  <div className="as-spinner"/> Cargando descargas…
                </div>
              ) : descargas.length === 0 ? (
                <div className="as-modal__empty">
                  <p>Este suscriptor aún no ha descargado ningún recurso.</p>
                  <span>Comparte los links de captación para que empiece a descargar.</span>
                </div>
              ) : (
                <div className="as-modal__descargas">
                  {descargas.map((d,i) => (
                    <div className="as-desc-item" key={i}>
                      <div className="as-desc-item__num">{i+1}</div>
                      <div className="as-desc-item__info">
                        <strong>{d.titulo || d.recurso_titulo || 'Recurso'}</strong>
                        <span>{d.tipo && <span className={`as-badge as-badge--verde`}>{d.tipo}</span>}</span>
                      </div>
                      <div className="as-desc-item__meta">
                        <span className="as-fuente">
                          {FUENTE_ICON[d.fuente]||<IconWeb/>} {d.fuente||'web'}
                        </span>
                        <span className="as-fecha">{d.fecha}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="as-modal__foot">
              <button className="as-btn-ghost" onClick={()=>setModalSusc(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}